import React from "react";

interface Props {
    isWhite?: boolean;
    textColorClassName?: string;
    onClick?: () => void;
}

export function Logo({ isWhite, textColorClassName, onClick }: Props) {
    return (
        <div
            className="flex items-center cursor-pointer"
            onClick={onClick}
        >
            <img
                src={isWhite ? '/logowhitetransp.jpg' : '/logopurpletransp.jpg'}
                alt="Logo"
                className="h-12 w-12 object-cover rounded"
            />
            <span className={`ml-1 text-sm font-bold ${textColorClassName ?? ""}`}>
                THESAI
            </span>
        </div>
    );
}
